// import React, { Fragment, useEffect, useState } from 'react'
// import chapterQueries from '../../queries/chapterQueries'
// import { useDispatch, useSelector } from 'react-redux'
// import BreadCrumbs from '../../components/BreadCrumbs'
// import { RouteConstant } from '../../routes/RouteConstant'
// import { setChapter } from '../../redux/reducers/masterReducers'
// import { useNavigate } from 'react-router-dom'
// import { setHeaderText, setLoader } from '../../redux/reducers/optionsReducers'
// import DonutChart from '../../components/DonutChart'
// import Loader from '../../components/Loader'

// const breadcrumb = [
//   {
//     label: "Vessels",
//     path: RouteConstant.VESSEL,
//     roles: ["SADMIN"]
//   },
//   {
//     label: "Vessel Details",
//     roles: ["CENG", "CAPT", "2E", "3E", "CMATE", "2M", "3M"],
//     path: RouteConstant.VESSELDETAILS
//   },
//   {
//     label: "Inspection History",
//     path: RouteConstant.INSPECTIONHISTORY
//   },
//   {
//     label: "Chapter Progress",
//   }
// ]

// const ChapterProgress = () => {

//   const inspection = useSelector((state)=> state.master.inspection)
//   const master = useSelector((state)=> state.master)
//   const loader = useSelector((state)=> state.options.loader)
//   const dispatch = useDispatch()
//   const navigate = useNavigate()

//   useEffect(() => {
//     dispatch(setLoader(true))
//     dispatch(setHeaderText(`Vessel : ${master?.header}`))
//   }, []);

//   const [result, setResult] = useState([])

//   const chapterList = chapterQueries.useChapterAssignedMutationInspectionList(
//     (res)=>{
//       dispatch(setLoader(false))
//       setResult(res)
//     }
//   )

//   useEffect(() => {
//     chapterList.mutateAsync({vessel: master.id, inspection: inspection, user: master?.isUserWise ? master?.user?.id : ""})
//   }, []);

//   const handleQuestion =(item)=>{
//     dispatch(setChapter({
//       id: item.id,
//       chapter_no: item?.chapter_no,
//       name: item?.name
//     }))
//     navigate(RouteConstant.QUESTIONPROGRESS)
//   }

//   const findCompleted =(item)=>{
//     const success = item?.totalActions
//     const total = item?.totalChecklists - item?.totalNotApplicables
//     return [success, total]
//   }

//   if(loader){
//     return <Loader />
//   }

//   return (
//     <Fragment>

//       <BreadCrumbs data={breadcrumb} />

//       <div className="chapters-list-cntnr mt-4">
//         <section>
//           <div className="chapters-list-wrpr">
//             {
//               result?.data?.map((item, index)=>(
//                 <div className="chapter-card bg-white" key={index} onClick={()=>{handleQuestion(item)}}>
//                   <div className="chapter-number">
//                     <div className="chapter-label">
//                       Chapter<span>{item?.chapter_no}</span>
//                     </div>
//                   </div>
//                   <div className="chapter-cntnt w-full">
//                     {item?.name}
//                   </div>
//                   <div className="chapter-graph">
//                     <div className="chart1" id="chart-container7">
//                       <DonutChart data={findCompleted(item)} />
//                     </div>
//                   </div>
//                 </div>
//               ))
//             }
//           </div>
//         </section>
//       </div>

//     </Fragment>
//   )
// }

// export default ChapterProgress






import React, { useEffect, useState } from 'react'
import chapterQueries from '../../queries/chapterQueries'
import { useDispatch, useSelector } from 'react-redux'
import BreadCrumbs from '../../components/BreadCrumbs'
import { RouteConstant } from '../../routes/RouteConstant'
import { setChapter } from '../../redux/reducers/masterReducers'
import { useNavigate } from 'react-router-dom'
import { setHeaderText, setLoader } from '../../redux/reducers/optionsReducers'
import Loader from '../../components/Loader'

const breadcrumb = [
  {
    label: "Vessels",
    path: RouteConstant.VESSEL,
    roles: ["SADMIN"]
  },
  {
    label: "Vessel Details",
    roles: ["CENG", "CAPT", "2E", "3E", "CMATE", "2M", "3M"],
    path: RouteConstant.VESSELDETAILS
  },
  {
    label: "Inspection History",
    path: RouteConstant.INSPECTIONHISTORY
  },
  {
    label: "Chapter Progress",
  }
]

const ChapterProgress = () => {

    const inspection = useSelector((state) => state.master.inspection)
    const master = useSelector((state) => state.master)
    const loader = useSelector((state) => state.options.loader)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
      dispatch(setLoader(true))
      dispatch(setHeaderText(`Vessel : ${master?.header}`))
    }, []);

    const [result, setResult] = useState([])
    const [activeTab, setActiveTab] = useState('all')

    const chapterList = chapterQueries.useChapterAssignedMutationInspectionList(
      (res) => {
        dispatch(setLoader(false))
        setResult(res)
      }
    )

    useEffect(() => {
      chapterList.mutateAsync({ vessel: master.id, inspection: inspection, user: master?.isUserWise ? master?.user?.id : "" })
    }, []);

    const handleQuestion = (item) => {
      dispatch(setChapter({
        id: item.id,
        chapter_no: item?.chapter_no,
        name: item?.name
      }))
      navigate(RouteConstant.QUESTIONPROGRESS)
    }
    
    const getCompletionPercentage = (item) => {
      return item?.successPercentage
    }

    const getStatusColor = (percentage) => {
      if(percentage >= 100) return { bg: 'bg-emerald-500', text: 'text-emerald-600', status: 'Completed' };
      if(percentage >= 1) return { bg: 'bg-amber-500', text: 'text-amber-600', status: 'In Progress' };
      return { bg: 'bg-rose-500', text: 'text-rose-600', status: 'Pending' };
    }
  
    const getFilteredData = () => {
      if(activeTab === 'all') return result?.data || [];
      if(activeTab === 'completed'){
        return (result?.data || [])?.filter(item => getCompletionPercentage(item) >= 100);
      }
      if(activeTab === 'inProgress'){
        return (result?.data || [])?.filter(item => {
          const percentage = getCompletionPercentage(item);
          return percentage >= 1 && percentage < 100;
        });
      }
      if(activeTab === 'pending'){
        return (result?.data || [])?.filter(item => getCompletionPercentage(item) < 1);
      }
      return result?.data || [];
    }
  
    const totalChapters = result?.data?.length || 0;
    const completedChapters = (result?.data || [])?.filter(item => getCompletionPercentage(item) >= 100).length;
    const inProgressChapters = (result?.data || [])?.filter(item => {
      const percentage = getCompletionPercentage(item);
      return percentage >= 1 && percentage < 100;
    }).length;

    const pendingChapters = (result?.data || [])?.filter(item => getCompletionPercentage(item) < 1).length;

    const [queuedChapterNo, setQueuedChapterNo] = useState(null);


    useEffect(() => {
      const handleKeyDown = (e) => {
        if (e.ctrlKey && e.shiftKey) {
          const match = e.code.match(/^Digit([0-9])$/);
          if (match) {
            const numberPressed = parseInt(match[1]);
            setQueuedChapterNo(numberPressed);
          }
        }
      };
    
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    useEffect(() => {
      if (!loader && queuedChapterNo !== null) {
        const matched = result?.data?.find(ch => ch.chapter_no === queuedChapterNo);
        if (matched) {
          dispatch(setChapter({
            id: matched.id,
            chapter_no: matched.chapter_no,
            name: matched.name
          }));
          navigate(RouteConstant.QUESTIONPROGRESS);
          setQueuedChapterNo(null);
        }
      }
    }, [loader, queuedChapterNo, result]);
    

    if(loader){
      return <Loader />
    }

  return (
    <div>
      <BreadCrumbs data={breadcrumb} />
      
      <div className="mt-4">

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-indigo-500 transform transition-all hover:scale-105 duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">Total Chapters</p>
                <p className="text-3xl font-bold text-gray-900 mt-1">{totalChapters}</p>
              </div>
              <div className="w-12 h-12 rounded-full bg-indigo-100 flex items-center justify-center">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                </svg>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-emerald-500 transform transition-all hover:scale-105 duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">Completed</p>
                <p className="text-3xl font-bold text-emerald-600 mt-1">{completedChapters}</p>
              </div>
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center">
                <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-amber-500 transform transition-all hover:scale-105 duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">In Progress</p>
                <p className="text-3xl font-bold text-amber-600 mt-1">{inProgressChapters}</p>
              </div>
              <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
                <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
                </svg>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-rose-500 transform transition-all hover:scale-105 duration-300">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-500">Pending</p>
                <p className="text-3xl font-bold text-rose-600 mt-1">{pendingChapters}</p>
              </div>
              <div className="w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center">
                <svg className="w-6 h-6 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              <button
                className={`mr-8 py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'all'
                    ? 'border-indigo-600 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                onClick={() => setActiveTab('all')}
              >
                All Chapters
              </button>
              <button
                className={`mr-8 py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'completed'
                    ? 'border-emerald-600 text-emerald-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                onClick={() => setActiveTab('completed')}
              >
                Completed
              </button>
              <button
                className={`mr-8 py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'inProgress'
                    ? 'border-amber-600 text-amber-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                onClick={() => setActiveTab('inProgress')}
              >
                In Progress
              </button>
              <button
                className={`py-4 px-1 border-b-2 font-medium text-sm ${
                  activeTab === 'pending'
                    ? 'border-rose-600 text-rose-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                onClick={() => setActiveTab('pending')}
              >
                Pending
              </button>
            </nav>
          </div>
        </div>

        {getFilteredData()?.length === 0 ? (
          <div className="bg-white rounded-xl shadow-md p-10 text-center">
            <div className="w-20 h-20 mx-auto bg-gray-100 rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
              </svg>
            </div>
            <h3 className="mt-4 text-lg font-medium text-gray-900">No chapters found</h3>
            <p className="mt-1 text-sm text-gray-500">No chapters matching the selected filter are available.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {getFilteredData()?.map((item, index) => {
              const completionPercentage = getCompletionPercentage(item);
              const { bg, text, status } = getStatusColor(completionPercentage);
              
              return (
                <div 
                  key={index} 
                  onClick={() => handleQuestion(item)}
                  className="group"
                >
                  <div className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-xl transform hover:scale-102 cursor-pointer">
                    <div className="p-6">
                      <div className="flex items-center mb-4">
                        <div className={`w-12 h-12 rounded-lg ${bg} bg-opacity-10 flex items-center justify-center mr-4`}>
                          <span className={`text-xl font-bold ${text}`}>{item?.chapter_no}</span>
                        </div>
                        <div className="flex-1">
                          <h3 className="text-lg font-bold text-gray-900 group-hover:text-indigo-600 transition-colors duration-200">
                            {item?.name}
                          </h3>
                          <div className="flex items-center mt-1">
                            <div className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${bg} text-white`}>
                              {status}
                            </div>
                            <span className="ml-2 text-sm text-gray-500">
                              {completionPercentage}% Complete
                            </span>
                          </div>
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between mb-4">
                        <div className="grid grid-cols-2 gap-x-8 gap-y-3 flex-1 pr-8">
                          <div className="flex items-center">
                            <div className="w-3 h-3 rounded-full bg-indigo-500 mr-2"></div>
                            <span className="text-sm text-gray-500">Total: </span>
                            <span className="text-sm font-medium text-gray-900 ml-1">{item?.totalChecklists}</span>
                          </div>
                          <div className="flex items-center">
                            <div className="w-3 h-3 rounded-full bg-emerald-500 mr-2"></div>
                            <span className="text-sm text-gray-500">Completed: </span>
                            <span className="text-sm font-medium text-gray-900 ml-1">{item?.successChecklist}</span>
                          </div>
                          <div className="flex items-center">
                            <div className="w-3 h-3 rounded-full bg-gray-300 mr-2"></div>
                            <span className="text-sm text-gray-500">N/A: </span>
                            <span className="text-sm font-medium text-gray-900 ml-1">{item?.notApplicableChecklist}</span>
                          </div>
                          <div className="flex items-center">
                            <div className="w-3 h-3 rounded-full bg-amber-500 mr-2"></div>
                            <span className="text-sm text-gray-500">Remaining: </span>
                            <span className="text-sm font-medium text-gray-900 ml-1">
                              {item?.totalChecklists - item?.successChecklist - item?.notApplicableChecklist}
                            </span>
                          </div>
                        </div>
                        
                        <div className="relative w-20 h-20">
                          <div className="absolute inset-0 flex items-center justify-center">
                            <svg className="w-20 h-20 transform -rotate-90" viewBox="0 0 100 100">
                              <circle
                                className="text-gray-200"
                                cx="50"
                                cy="50"
                                r="40"
                                stroke="currentColor"
                                strokeWidth="10"
                                fill="none"
                              />
                              <circle
                                className={text.replace('text', 'text')}
                                cx="50"
                                cy="50"
                                r="40"
                                stroke="currentColor"
                                strokeWidth="10"
                                fill="none"
                                strokeDasharray="251.2"
                                strokeDashoffset={(100 - completionPercentage) * 2.512}
                              />
                            </svg>
                            <div className="absolute inset-0 flex items-center justify-center">
                              <span className="text-xl font-bold text-gray-800">{completionPercentage}%</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="mt-4 relative">
                        <div className="overflow-hidden h-2 text-xs flex rounded bg-gray-200">
                          <div
                            style={{ width: `${completionPercentage}%` }}
                            className={`shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center ${bg}`}
                          ></div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                      <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default ChapterProgress